import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Branch.svg?component
var Branch_exports = /* @__PURE__ */ __exportAll({
	default: () => Branch_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
		createElementVNode("path", { d: "M16.4 6.8v5.6H7.6m0-5.6v10.4" }, null, -1),
		createElementVNode("circle", {
			cx: "7.6",
			cy: "4.4",
			r: "2.4"
		}, null, -1),
		createElementVNode("circle", {
			cx: "7.6",
			cy: "19.6",
			r: "2.4"
		}, null, -1),
		createElementVNode("circle", {
			cx: "16.4",
			cy: "4.4",
			r: "2.4"
		}, null, -1)
	])]);
}
var Branch_default = { render: render$1 };
//#endregion
export { Branch_exports, Branch_default as default, render$1 as render };

//# sourceMappingURL=Branch.svg.virtual.js.map